import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { Provider } from 'react-redux';
import { store } from './utils/store';

createRoot(document.getElementById('root') as HTMLElement)
  .render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );